/**
 * Sentry noise-gate — decides whether a failure should be reported to Sentry.
 *
 * Expected/user-facing failures (fullbooked, validation, too_large, deadline)
 * are tracked in PostHog only. Unexpected failures (network, rls_403, unknown,
 * storage, server_5xx) are reported to Sentry for alerting.
 */

/** Reasons that are "expected" and should NOT go to Sentry */
const EXPECTED_REASONS: Record<string, Set<string>> = {
  activity_publish: new Set(["validation"]),
  activity_draft_save: new Set(["validation"]),
  booking: new Set(["fullbooked", "deadline", "validation"]),
  media_upload: new Set(["too_large", "user_cancelled", "validation"]),
  // media_finalize: always report (no expected reasons except user_cancelled)
  media_finalize: new Set(["user_cancelled"]),
};

export function shouldReportToSentry(
  feature: string,
  failureReason: string,
): boolean {
  const expected = EXPECTED_REASONS[feature];

  // If we have no rules for this feature, always report
  if (!expected) return true;

  return !expected.has(failureReason);
}
